<template>
  <div v-if="!integerSize && !decimalSize">{{ formattedPrice }}</div>
  <div v-else class="flex items-baseline" :class="{'flex-col': shouldBreakLine}">
    <span :style="symbolStyle" :class="{'mb-3': shouldBreakLine}">{{ currencySymbol }}</span>
    <div class="flex items-baseline">
      <span :style="integerStyle">{{ parsedPrice.integer }}</span>
      <span v-if="parsedPrice.decimal" :style="decimalStyle">{{ parsedPrice.decimal }}</span>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from "vue";
  import { currencyFormat } from '../../components/exchange_rates.js';

  export default defineComponent({
    props: {
      price: { type: [Number, String], required: true },
      integerSize: { type: Number, default: null },
      decimalSize: { type: Number, default: null },
      symbolBreakLine: { type: Boolean, default: false },
      symbolSize: { type: Number, default: null }
    },
    
    data() {
      return {
        currency: 'USD',
        rate: null,
      };
    },
    mounted() {
      const exchangeRatesData = localStorage.getItem('exchangeRatesData');
      this.currency = window.global_values['CURRENCY'];
      // 交易對格式 USDJPY,USDTWD
      // 沒有匯率的話就用 USD
      if(exchangeRatesData) {
        this.rate = JSON.parse(exchangeRatesData).rates[`USD${this.currency}`]['Exrate']
      } else {
        this.currency = 'USD'
        this.rate = 1
      }
    },
    computed: {
      // 統一轉換 price 為數字類型，支援 String/Number 輸入
      numericPrice() {
        if (typeof this.price === 'string') {
          const parsed = parseFloat(this.price)
          return isNaN(parsed) ? 0 : parsed
        }
        return typeof this.price === 'number' ? this.price : 0
      },
      
      formattedPrice() {
        let price = this.numericPrice

        if (price >= 0) {
          return currencyFormat[this.currency]['unit'] + ` ${(price * this.rate).toFixed(currencyFormat[this.currency]['decimal'])}`
        } else {
          price = Math.abs(price)
          return '-' + currencyFormat[this.currency]['unit'] + ` ${(price * this.rate).toFixed(currencyFormat[this.currency]['decimal'])}`
        }
      },
      
      currencySymbol() {
        return currencyFormat[this.currency]['unit']
      },
      
      // 統一的價格解析邏輯，避免重複的字串處理
      parsedPrice() {
        if (!this.formattedPrice) return { integer: '0', decimal: '' }
        
        const fullPrice = this.formattedPrice.replace(this.currencySymbol, '').replace(/^-/, '').trim()
        const [integer, decimal] = fullPrice.split('.')
        return {
          integer: (this.numericPrice < 0 ? '-' : '') + (integer || '0'),
          decimal: decimal ? '.' + decimal : ''
        }
      },
      
      
      integerStyle() {
        return {
          fontSize: this.integerSize ? `${this.integerSize}px` : undefined,
          fontWeight: 'medium'
        }
      },
      
      decimalStyle() {
        return {
          fontSize: this.decimalSize ? `${this.decimalSize}px` : undefined
        }
      },
      
      symbolStyle() {
        const fontSize = this.symbolSize || this.integerSize
        return {
          fontSize: fontSize ? `${fontSize}px` : undefined,
          fontWeight: 'medium'
        }
      },
      
      shouldBreakLine() {
        // 只有當 symbolBreakLine 為 true 且 currencySymbol 為 'NT$' 時才換行
        return this.symbolBreakLine && this.currencySymbol === 'NT$'
      }
    }
  })
</script>
